import React from 'react';

import { FIELD_COMPONENTS } from '@atlas/react-forms';

import CheckboxField from 'common/Form/Fields/CheckboxField';
import ComplexPasswordField from 'common/Form/Fields/ComplexPasswordField';
import DaypickerField from 'common/Form/Fields/DaypickerField';
import DepositField from 'common/Form/Fields/DepositField';
import EmailWithVerification from 'common/Form/Fields/EmailWithVerificationField';
import FileField from 'common/Form/Fields/FileField';
import InputWithActionButton from 'common/Form/Fields/InputWithActionButton';
import MoneyAmountField from 'common/Form/Fields/MoneyAmountField';
import NumberField from 'common/Form/Fields/NumberField/NumberField';
import PasswordField from 'common/Form/Fields/PasswordField';
import PhoneField from 'common/Form/Fields/PhoneField';
import RadioSelectField from 'common/Form/Fields/RadioSelectField';
import SelectField from 'common/Form/Fields/SelectField';
import SelectorField from 'common/Form/Fields/SelectorField/SelectorField';
import TextField from 'common/Form/Fields/TextField';

import SmsCodeField from '../Fields/SmsCodeField/SmsCodeField';

const {
  CHECKBOX,
  COMPLEX_PASSWORD,
  CURRENCYPICKER,
  EMAIL_WITH_VERIFICATION,
  FILE,
  LIST,
  NUMBER,
  PASSWORD,
  PHONE,
  PHONE_WITH_VERIFICATION,
  SELECT,
  SELECTOR,
  SMS_CODE,
  STRING,
  TEXT,
  TIMESTAMP,
} = FIELD_COMPONENTS;

export const fieldComponents = {
  [CHECKBOX]: CheckboxField,
  [COMPLEX_PASSWORD]: ComplexPasswordField,
  [CURRENCYPICKER]: SelectField,
  [EMAIL_WITH_VERIFICATION]: EmailWithVerification,
  [FILE]: FileField,
  [LIST]: SelectField,
  [NUMBER]: NumberField,
  [PASSWORD]: PasswordField,
  [PHONE]: PhoneField,
  [PHONE_WITH_VERIFICATION]: PhoneField,
  [SELECT]: SelectField,
  [SELECTOR]: props => <SelectorField {...{ fieldComponents }} {...props} />,
  [SMS_CODE]: SmsCodeField,
  [STRING]: TextField,

  // Backend Form fields
  [TEXT]: TextField,
  [TIMESTAMP]: DaypickerField,
  checkbox: CheckboxField,
  countrypicker: SelectField,
  daypicker: DaypickerField,
  depositInput: DepositField,
  file: FileField,
  inputWithActionButton: InputWithActionButton,
  moneyInput: DepositField,
  moneyamount: MoneyAmountField,
  password: PasswordField,
  radioselect: RadioSelectField,
  select: SelectField,
  text: TextField,
};
